import { render, staticRenderFns } from "./Logotype.vue?vue&type=template&id=71d3c40e&scoped=true&"
import script from "./Logotype.vue?vue&type=script&lang=js&"
export * from "./Logotype.vue?vue&type=script&lang=js&"
import style0 from "./Logotype.vue?vue&type=style&index=0&id=71d3c40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d3c40e",
  null
  
)

export default component.exports